var Base = require('_js/base'),
  ko = require('knockout');

var model = function(params) {
  this.params = params;
};

function CourseRegistrationParticipants() {
  this.init();
}

CourseRegistrationParticipants.prototype = new Base();

CourseRegistrationParticipants.prototype.init = function() {
  var $courseRegistrationParticipants = $(
    '[data-course-registration-participants]'
  );
  if ($courseRegistrationParticipants.get(0) !== undefined) {
    ko.applyBindings(
      new model({
        element: $courseRegistrationParticipants.data(
          'course-registration-participants'
        )
      }),
      $courseRegistrationParticipants.get(0)
    );
  }
};

module.exports = CourseRegistrationParticipants;
